import { Modal } from 'antd';
import { useAppTranslation } from 'app/hooks';
import CloseIcon from 'assets/icons/CloseIcon';
import useThemes from 'hooks/useThemes';
import React, { useEffect } from 'react';
import { Connector, useConnect, useDisconnect } from 'wagmi';
import walletconnect_icon from 'assets/icons/walletconnect_icon.svg';
import Typo from 'consts/typography';

interface CryptoWalletModalProps {
  isOpen: boolean;
  onCancel: () => void;
}

const wallets = [
  {
    id: 'walletConnect',
    logo: walletconnect_icon,
  },
];

const CryptoWalletModal: React.FunctionComponent<CryptoWalletModalProps> = ({
  isOpen,
  onCancel,
}) => {
  const { currentTheme } = useThemes();
  const t = useAppTranslation();
  const { connectors, connect, isSuccess, isPending, isError } = useConnect();
  const { disconnect } = useDisconnect();
  const handleConnectWallet = (connector: Connector) => {
    connect({ connector });
  };

  const getCryptoWalletLogo = (connector: Connector) => {
    if (connector.icon) return connector.icon;
    return wallets.find((x) => (x.id = connector.id))?.logo || undefined;
  };

  const onClose = () => {
    if (isPending) return;
    onCancel();
  };

  useEffect(() => {
    if (isSuccess) {
      onCancel();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      onCancel();
      disconnect();
    }
  }, [isError]);

  return (
    <Modal
      className="common-modal"
      title="Connect to Terabet"
      footer={null}
      visible={isOpen}
      centered
      maskClosable={false}
      closeIcon={<CloseIcon isDarkMode={currentTheme === 'dark'} width="20" height="20" />}
      width={450}
      onCancel={onClose}
    >
      <div className="payment-methods primary-text-color">
        {isPending ? (
          <div className="text-center w-100">
            <p className={`font-bold ${Typo.p2}`}>{t('common.connecting')}...</p>
          </div>
        ) : (
          <>
            {connectors.map((connector) => (
              <button
                key={`crypto-wallet-${connector.id}`}
                className="payment-method"
                onClick={() => handleConnectWallet(connector)}
              >
                <img src={getCryptoWalletLogo(connector)} alt="payment method" />
                <p className="primary-text-color">{connector.name}</p>
              </button>
            ))}
          </>
        )}
      </div>
    </Modal>
  );
};

export default CryptoWalletModal;
